// extracted by mini-css-extract-plugin
export var content = "_nh-1";
export var noScroll = "_nh-3";
export var paper = "_nh-0";
export var scrollable = "_nh-2";